import { useFormik } from 'formik'
import React from 'react'
import ModalComponent from '..'
import { Button } from '../../button'
import { TextInput } from '../../inputs/textInput'

import { POSTerminalSchema } from '../../../validation/validate'

import {
  useCreateTerminalMutation,
  useUpdateTerminalMutation,
} from '../../../redux-toolkits/terminals/terminals.slice'
import { DateInput } from '../../inputs/dateInput'
import { formatDate, parseDateStringToDate } from '../../../helpers'
import { SingleTerminal } from '../../../redux-toolkits/terminals/terminals.types'

export const AddPOSModal: React.FC<{
  open: boolean
  setOpen: (cal: boolean) => void
  onCloseCallback?: () => void
  onSuccessCallback?: () => void
  fulfilmentCentreId: string
  pos?: SingleTerminal | null
}> = ({
  open,
  setOpen,
  onCloseCallback = () => {},
  onSuccessCallback = () => {},
  fulfilmentCentreId,
  pos,
}) => {
  const [createTerminal, { isLoading: creating }] = useCreateTerminalMutation()
  const [updateTerminal, { isLoading: updating }] = useUpdateTerminalMutation()

  const {
    values,
    errors,
    handleSubmit,
    handleChange,
    handleBlur,
    touched,
    isValid,
    resetForm,
    setFieldValue,
  } = useFormik({
    initialValues: {
      tag: pos?.tag ?? '',
      terminalId: pos?.terminalId ?? '',
      provider: pos?.provider ?? '',
      acquisitionDate: pos?.acquisitionDate ?? '',
      assignedTo: pos?.metadata?.assignedTo ?? '',
      serialNumber: pos?.metadata?.serialNumber ?? '',
    },
    enableReinitialize: true,
    validationSchema: POSTerminalSchema,
    onSubmit: async (values) => {
      let success: boolean = false

      const payload = {
        tag: values.tag,
        provider: values.provider,
        acquisitionDate: values.acquisitionDate,
        fulfilmentCentreId,
        metadata: {
          assignedTo: values.assignedTo,
          serialNumber: values.serialNumber,
        },
      }

      if (pos?.terminalId) {
        const resp = await updateTerminal({ body: payload, id: pos.terminalId })
        success = resp?.data?.success ?? false
      } else {
        const resp = await createTerminal({
          ...payload,
          terminalId: values.terminalId,
        })
        success = resp?.data?.success ?? false
      }

      if (success) {
        resetForm()
        setOpen(false)
        onSuccessCallback()
      }
    },
  })
  return (
    <ModalComponent
      open={open}
      setOpen={setOpen}
      onCloseCallback={() => {
        resetForm()
        onCloseCallback()
      }}
      title={'Add POS Terminal'}
      childrenClassName="md:!max-w-[420px]"
    >
      <form className="flex flex-col gap-4" onSubmit={handleSubmit}>
        <TextInput
          type="text"
          name="tag"
          placeholder="Tag"
          value={values.tag}
          onBlur={handleBlur}
          onChange={handleChange}
          errors={errors.tag && touched.tag ? errors.tag : ''}
          hasIcon={false}
        />
        <div className="grid grid-cols-2 gap-4">
          <TextInput
            type="text"
            name="terminalId"
            placeholder="Terminal Id"
            value={values.terminalId}
            onBlur={handleBlur}
            onChange={handleChange}
            errors={
              errors.terminalId && touched.terminalId ? errors.terminalId : ''
            }
            hasIcon={false}
          />

          <TextInput
            type="text"
            name="provider"
            placeholder="Provider"
            value={values.provider}
            onBlur={handleBlur}
            onChange={handleChange}
            errors={errors.provider && touched.provider ? errors.provider : ''}
            hasIcon={false}
          />
        </div>

        <TextInput
          type="text"
          name="assignedTo"
          placeholder="Assigned To"
          value={values.assignedTo}
          onBlur={handleBlur}
          onChange={handleChange}
          errors={
            errors.assignedTo && touched.assignedTo ? errors.assignedTo : ''
          }
          hasIcon={false}
        />

        <TextInput
          type="text"
          name="serialNumber"
          placeholder="Serial Number"
          value={values.serialNumber}
          onBlur={handleBlur}
          onChange={handleChange}
          errors={
            errors.serialNumber && touched.serialNumber
              ? errors.serialNumber
              : ''
          }
          hasIcon={false}
        />

        <DateInput
          name="acquisitionDate"
          onBlur={handleBlur}
          placeholder="Select date"
          errors={
            errors.acquisitionDate && touched.acquisitionDate
              ? errors.acquisitionDate
              : ''
          }
          title="Acquisition Date"
          date={parseDateStringToDate(
            values.acquisitionDate,
            'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]',
            true,
          )}
          setDate={(date) => {
            setFieldValue(
              'acquisitionDate',
              formatDate(date, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]'),
            )
          }}
          dateFormat="MMM DD, YYYY"
        />

        <Button
          label="Proceed"
          type="submit"
          className="mt-10"
          disabled={!isValid || creating}
          loading={creating}
          primary
        />
      </form>
    </ModalComponent>
  )
}
